export default __webpack_public_path__ + "static/media/check_circle.7d713c94.svg";